import { render, staticRenderFns } from "./ShippingDocReviewModal.vue?vue&type=template&id=22c6ddd3&scoped=true"
import script from "./ShippingDocReviewModal.vue?vue&type=script&lang=js"
export * from "./ShippingDocReviewModal.vue?vue&type=script&lang=js"
import style0 from "./ShippingDocReviewModal.vue?vue&type=style&index=0&id=22c6ddd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c6ddd3",
  null
  
)

export default component.exports